import { z } from 'zod';

// Validation schemas for form data
// These ensure data quality and consistent format before database insertion

// Hebrew and English letters, spaces, hyphens, and apostrophes
const nameRegex = /^[\u0590-\u05FFa-zA-Z\s'-]+$/;

// International phone format with optional country code
const phoneRegex = /^[0-9+\-().\s]{9,15}$/;

export const leadSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, { message: "שם חייב להכיל לפחות 2 תווים" })
    .max(100, { message: "שם ארוך מדי (מקסימום 100 תווים)" })
    .regex(nameRegex, { message: "שם יכול להכיל רק אותיות, רווחים ומקפים" }),
  phone: z
    .string()
    .trim()
    .min(9, { message: "מספר טלפון קצר מדי" })
    .max(15, { message: "מספר טלפון ארוך מדי" })
    .regex(phoneRegex, { message: "מספר טלפון לא תקין" }),
  email: z
    .string()
    .trim()
    .email({ message: "כתובת אימייל לא תקינה" })
    .max(255, { message: "אימייל ארוך מדי" })
    .optional()
    .or(z.literal("")),
});

export const quizLeadSchema = leadSchema.extend({
  email: z
    .string()
    .trim()
    .email({ message: "כתובת אימייל לא תקינה" })
    .max(255, { message: "אימייל ארוך מדי" }),
  quiz_q1: z.string().max(500, { message: "תשובה ארוכה מדי" }).optional().nullable(),
  quiz_q2: z.string().max(500, { message: "תשובה ארוכה מדי" }).optional().nullable(),
  quiz_q3: z.string().max(500, { message: "תשובה ארוכה מדי" }).optional().nullable(),
});

export const waitlistSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, { message: "שם חייב להכיל לפחות 2 תווים" })
    .max(100, { message: "שם ארוך מדי (מקסימום 100 תווים)" })
    .regex(nameRegex, { message: "שם יכול להכיל רק אותיות, רווחים ומקפים" }),
  email: z
    .string()
    .trim()
    .email({ message: "כתובת אימייל לא תקינה" })
    .max(255, { message: "אימייל ארוך מדי" }),
  phone: z
    .string()
    .trim()
    .min(9, { message: "מספר טלפון קצר מדי" })
    .max(15, { message: "מספר טלפון ארוך מדי" })
    .regex(phoneRegex, { message: "מספר טלפון לא תקין" }),
});

// Helper function to get first validation error message
export function getValidationError(result: z.SafeParseReturnType<unknown, unknown>): string | null {
  if (result.success) return null;
  const firstError = result.error.errors[0];
  return firstError?.message || "שגיאה בנתונים";
}
